const trackersTypes = {
  SET_GCLID: "SET_GCLID",
  RESET_GCLID: "RESET_GCLID",
};

export default trackersTypes;
